const SegnalazioneType = {
    STOR:"STOR",
    MARKET_OBSERVATION: "Market Observation",
    HELP_DESK_STOR: "HELP_DESK_STOR",
    ALTRO : "ALTRO"
}

export default SegnalazioneType
